const translations = {
    buttonText: 'Learn More',
    modalText: 'This feature is available for QuickBooks® connected customers only',
    modalTitle: 'Customer Not Supported'
};

export default translations;
